import { css } from "lit";

export const audioAlertStyles = css`
    :host {
      display: block;
      font-family: "Maersk Text", sans-serif;
      color: #333;
    }

    .content {
        padding: 1rem 0rem 0rem 0rem;
        height: 25rem;
    }

    .header {
        font-size: 22px;
        padding-left: 24px;
    }

    .modal-content {
      display: flex;
      align-items: center;
      gap: 3rem;
      padding: 1.5rem 2rem;
      min-width: 650px;
      min-height: 55%;
    }

    .modal-content-test {
      display: flex;
      align-items: center;
      gap: 2rem;
      padding: 0rem 1.5rem 3rem 2rem;
      min-width: 650px;
      height: 55%;
    }
    
    .left {
      flex-shrink: 0;
      width: 12rem;
      height: 12rem;
      border-radius: 50%;
      background: #e6f1fb;
      display: flex;
      align-items: center;
      justify-content: center;
      margin-left: 5rem;
    }

    .right {
      flex: 1;
      font-size: 15px;
      line-height: 1.5;
      margin-left: 4rem;
    }

    .badge {
      background: #E8F6D0;
      font-size: 16px;
      padding: 2px 8px;
      border-radius: 10px;
      margin-left: 8px;
    }

    .footer {
      border-top: 1px solid #eee;
      padding: 0.5rem 2rem;
      display: flex;
      justify-content: flex-end;
      gap: 0.75rem;
      background: #fafafa;
      border-radius: 0px 0px 15px 15px;
    }

    .troubleshooting {
        padding-top: 1.5rem;
    }

    .minimize {
        display: flex;
        justify-content: flex-end;
    }

    .minimize-button {
        margin: 10px;
        background: none;
        border: none;
        outline: none;
        cursor: pointer;
    }

    .sound-permissions {
       width: 24rem;
       height: 15rem;
    }
`